import * as Constants from "../constants";
import * as InitialStates from "../constants/initialStates";
import * as LiveSessionStates from "../constants/liveSessionStates";
import * as LiveSessionEvents from "../constants/liveSessionEvents";
import {
  mapLiveSessionData,
  mapLiveSessionStateChange,
  mapLiveSessionDomainData,
} from "../mappers";

export default function liveSessionReducer(
  state = InitialStates.getInitialLiveSessionState(),
  action
) {
  switch (action?.type) {
    case Constants.SET_LIVE_SESSION_INITIAL_STATE:
      return InitialStates.getInitialLiveSessionState();
    case Constants.GET_ACTIVE_LIVE_SESSION_BY_COURSE:
    case Constants.CREATE_LIVE_SESSION:
    case Constants.UPDATE_LIVE_SESSION:
    case Constants.SET_LIVE_SESSION_STATE: {
      return {
        ...state,
        loading: true,
      };
    }
    case Constants.GET_LIVE_SESSION: {
      const { liveChannel, liveSession, webSocket, ...initialState } =
        InitialStates.getInitialLiveSessionStateDomain();
      return {
        liveChannel: state?.liveChannel || liveChannel,
        webSocket: state?.webSocket || webSocket,
        liveSession: state?.liveSession || liveSession,
        ...initialState,
        loading: true,
      };
    }
    case Constants.GET_ACTIVE_LIVE_SESSION_BY_COURSE_SUCCESS: {
      const data = action.payload.liveSessions?.[0];
      const { initialLiveSession, ...initialState } = InitialStates.getInitialLiveSessionState();

      return {
        ...initialState,
        liveSessionFetchSuccess: true,
        ...mapLiveSessionDomainData(data, state?.liveSession || initialLiveSession),
      };
    }
    case Constants.GET_LIVE_SESSION_SUCCESS: {
      const data = action.payload;
      return {
        ...InitialStates.getInitialLiveSessionStateDomain(),
        liveSessionFetchSuccess: true,
        ...mapLiveSessionDomainData(data, state),
      };
    }
    case Constants.CREATE_LIVE_SESSION_SUCCESS: {
      const data = action.payload;
      return {
        ...InitialStates.getInitialLiveSessionState(),
        liveSessionCreated: true,
        ...mapLiveSessionData(data),
      };
    }
    case Constants.UPDATE_LIVE_SESSION_SUCCESS: {
      const data = action.payload;
      return {
        ...InitialStates.getInitialLiveSessionState(),
        liveSessionUpdated: true,
        ...mapLiveSessionData(data),
      };
    }
    case Constants.SET_LIVE_SESSION_STATE_SUCCESS[LiveSessionEvents.READY]: {
      return mapLiveSessionStateChange({
        data: action.payload,
        stateChangeEvent: LiveSessionEvents.READY,
        state,
      });
    }
    case Constants.SET_LIVE_SESSION_STATE_SUCCESS[LiveSessionEvents.STREAMING]: {
      return mapLiveSessionStateChange({
        data: action.payload,
        stateChangeEvent: LiveSessionEvents.STREAMING,
        state,
      });
    }
    case Constants.SET_LIVE_SESSION_STATE_SUCCESS[LiveSessionEvents.FINISH]: {
      return mapLiveSessionStateChange({
        data: action.payload,
        stateChangeEvent: LiveSessionEvents.FINISH,
        state,
      });
    }
    case Constants.SET_LIVE_SESSION_STATE_SUCCESS[LiveSessionEvents.CANCEL]: {
      return mapLiveSessionStateChange({
        data: action.payload,
        stateChangeEvent: LiveSessionEvents.CANCEL,
        state,
      });
    }
    case Constants.SET_LOCAL_LIVE_SESSION_STREAMING: {
      const { liveSession: stateLiveSession } = state || {};
      const { liveSession: initialLiveSession } = InitialStates.getInitialLiveSessionState();
      const getLiveSession = (baseLiveSession) => ({
        ...baseLiveSession,
        aasmState: LiveSessionStates.STREAMING,
        updatedAt: new Date().toString(),
      });

      return {
        ...state,
        liveSession: getLiveSession(stateLiveSession || initialLiveSession),
      };
    }
    case Constants.GET_ACTIVE_LIVE_SESSION_BY_COURSE_ERROR:
    case Constants.GET_LIVE_SESSIONS_LIST_ERROR: {
      return {
        ...InitialStates.getInitialLiveSessionState(),
        errorFetching: true,
      };
    }

    case Constants.GET_LIVE_SESSION_ERROR: {
      return {
        ...InitialStates.getInitialLiveSessionStateDomain(),
        errorFetching: true,
      };
    }
    case Constants.CREATE_LIVE_SESSION_ERROR:
    case Constants.UPDATE_LIVE_SESSION_ERROR:
    case Constants.SET_LIVE_SESSION_STATE_ERROR[LiveSessionEvents.READY]:
    case Constants.SET_LIVE_SESSION_STATE_ERROR[LiveSessionEvents.STREAMING]:
    case Constants.SET_LIVE_SESSION_STATE_ERROR[LiveSessionEvents.FINISH]:
    case Constants.SET_LIVE_SESSION_STATE_ERROR[LiveSessionEvents.CANCEL]: {
      const { liveSession, liveChannel, webSocket, ...initialState } =
        InitialStates.getInitialLiveSessionState();
      return {
        ...initialState,
        liveSession: state?.liveSession || liveSession,
        liveChannel: state?.liveChannel || liveChannel,
        webSocket: state?.webSocket || webSocket,
        errorSaving: true,
      };
    }
    default:
      return state;
  }
}
